import ModalAmenities from './ModalAmenities';
export default ModalAmenities;
